import React, { useEffect, useState } from 'react'

import { get_problema_thread } from '../api';
import { ErrorBlockGeneric } from '../components';
import { Formik } from 'formik';


type Thread = Awaited<ReturnType<typeof get_problema_thread>>


const RispondiProblemaMultiplo = (props: { thread: Thread }) => {
  const [error, setError] = useState(null);

  return (
    <div className="container">
      <h1 className="page-header">Rispondi al problema</h1>
      <ErrorBlockGeneric error={error} />
      <h3>Le risposte vecchie che hai già dato</h3>
      <Formik
        initialValues={{}}
        onSubmit={() => {}}
      >
        {({ values }) => {
          return (
            <div />
          )
        }}
      </Formik>
    </div>
  )
}


export default RispondiProblemaMultiplo;
